import { ArrowRight } from 'lucide-react';
import { caseStudies, leadTypes } from '../data/site';

type Page = 'home' | 'services' | 'case-studies' | 'industries' | 'about' | 'insights' | 'contact';

export function CaseStudies({ onNavigate }: { onNavigate: (page: Page) => void }) {
  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="max-w-4xl">
        <p className="section-eyebrow">Case Studies</p>
        <h1 className="section-title">High-value consulting offers for platform transformation.</h1>
        <p className="mt-5 text-lg leading-8 text-slate-600">
          Use focused engagements to assess architecture, identify modernisation priorities, and de-risk delivery before
          moving into larger transformation programmes.
        </p>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {caseStudies.map((item) => (
          <article key={item.title} className="overflow-hidden rounded border border-slate-200 bg-white shadow-soft">
            <img src={item.image} alt="" className="h-56 w-full object-cover" loading="lazy" />
            <div className="p-5">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-cyan">{item.sector}</p>
              <h2 className="mt-3 text-xl font-bold">{item.title}</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600">{item.text}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-12 rounded bg-white p-6 shadow-soft">
        <h2 className="text-2xl font-bold">Lead generation focus</h2>
        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {leadTypes.map((item) => (
            <p key={item} className="border-l-4 border-cyan bg-cloud px-4 py-3 text-sm font-semibold">
              {item}
            </p>
          ))}
        </div>
        <button className="btn-primary mt-8" onClick={() => onNavigate('contact')}>
          Scope an engagement <ArrowRight size={18} aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
